// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__h5J7N","name":"styles_name__Ox1EB","phone":"styles_phone__-9WEE"};